export default "__VITE_ASSET__CJCpSlgC__"